import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchStoresNearby } from "../../services/api";

export const loadDiscoverStores = createAsyncThunk(
    "storeDiscover/load",
    async ({ city, category, lat, lon, reset = false }, { getState, rejectWithValue }) => {
        try {
            const cursor = reset ? null : getState().storeDiscover.nextCursor;
            const res = await fetchStoresNearby({ mode: "discover", city, category, cursor, lat, lon });
            return {
                items: res?.data?.items ?? [],
                nextCursor: res?.data?.nextCursor ?? null,
                reset,
                category,
            };
        } catch (err) {
            return rejectWithValue(err?.message || "Couldn't load stores.");
        }
    }
);

const storeDiscoverSlice = createSlice({
    name: "storeDiscover",
    initialState: {
        items: [],
        nextCursor: null,
        loading: false,
        loadingMore: false,
        error: null,
        loadedCategory: null,
    },
    reducers: {
        resetStoreDiscover: () => ({
            items: [], nextCursor: null, loading: false, loadingMore: false, error: null, loadedCategory: null,
        }),
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadDiscoverStores.pending, (state, action) => {
                if (action.meta.arg.reset) state.loading = true;
                else state.loadingMore = true;
                state.error = null;
            })
            .addCase(loadDiscoverStores.fulfilled, (state, action) => {
                state.loading = false;
                state.loadingMore = false;
                state.items = action.payload.reset ? action.payload.items : [...state.items, ...action.payload.items];
                state.nextCursor = action.payload.nextCursor;
                state.loadedCategory = action.payload.category;
            })
            .addCase(loadDiscoverStores.rejected, (state, action) => {
                state.loading = false;
                state.loadingMore = false;
                state.error = action.payload;
            });
    },
});

export const { resetStoreDiscover } = storeDiscoverSlice.actions;
export default storeDiscoverSlice.reducer;